/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AddVisitPackageTemplateDto
 */
export interface AddVisitPackageTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof AddVisitPackageTemplateDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AddVisitPackageTemplateDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AddVisitPackageTemplateDto
     */
    'type': AddVisitPackageTemplateDtoTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AddVisitPackageTemplateDtoTypeEnum {
    Epilepsy = 'EPILEPSY',
    Consultation = 'CONSULTATION'
}


